import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import '../components/Hero.css';

const CONSTRUCTION_DATA = [
  // Standards & Codes - construction_standards.sy
  { kind: 'struct', name: 'RegulatoryBody', sig: 'struct { name, abbreviation, jurisdiction, scope, key_standard, citation }', module: 'construction_standards', cat: 'Standards & Codes', keys: '' },
  { kind: 'struct', name: 'MasterFormatDivision', sig: 'struct { number, title, scope }', module: 'construction_standards', cat: 'Standards & Codes', keys: '' },
  { kind: 'struct', name: 'Div07Section', sig: 'struct { section_number, title, scope, key_astm, ibc_reference }', module: 'construction_standards', cat: 'Standards & Codes', keys: '' },
  { kind: 'struct', name: 'MaterialRule', sig: 'struct { rule_id, severity, material_a, material_b, constraint, mechanism, citation }', module: 'construction_standards', cat: 'Standards & Codes', keys: '' },
  { kind: 'struct', name: 'FailureMode', sig: 'struct { condition, threshold, action, citation }', module: 'construction_standards', cat: 'Standards & Codes', keys: '' },
  { kind: 'struct', name: 'AuthorityRequirement', sig: 'struct { activity, required_authority, basis, citation }', module: 'construction_standards', cat: 'Standards & Codes', keys: '' },
  { kind: 'struct', name: 'ClimateZoneRValue', sig: 'struct { zone, description, roof_r_value, wall_r_value, citation }', module: 'construction_standards', cat: 'Standards & Codes', keys: '' },
  { kind: 'fn', name: 'regulatory_body', sig: 'regulatory_body(abbr: String) -> RegulatoryBody', module: 'construction_standards', cat: 'Standards & Codes', keys: 'ASTM, ICC, NFPA, OSHA, ANSI, ASCE, ACI, AISC, AWS, ASHRAE, SMACNA, NRCA, SPRI, IIBEC, FM, UL, CSI' },
  { kind: 'fn', name: 'masterformat_division', sig: 'masterformat_division(num: Int) -> MasterFormatDivision', module: 'construction_standards', cat: 'Standards & Codes', keys: 'Div 00-33: Procurement, General, Concrete, Masonry, Metals, Wood, Div 07 Thermal/Moisture, Openings, Finishes, ...' },
  { kind: 'fn', name: 'div07_section', sig: 'div07_section(section: String) -> Div07Section', module: 'construction_standards', cat: 'Standards & Codes', keys: '07_10_00 Waterproofing, 07_20_00 Insulation, 07_30_00 Steep Slope, 07_50_00 Membrane, 07_60_00 Flashing, 07_80_00 Fire, 07_90_00 Sealants' },
  { kind: 'fn', name: 'material_compatibility', sig: 'material_compatibility(rule_id: Int) -> MaterialRule', module: 'construction_standards', cat: 'Standards & Codes', keys: 'EPDM/bitumen, PVC/asphalt, copper/aluminum, galvanized/ACQ, polyiso/thermal barrier, TPO/EPS, silicone/bitumen, solvents/EPS, dissimilar metals, SPF/UV' },
  { kind: 'fn', name: 'failure_mode', sig: 'failure_mode(condition: String) -> FailureMode', module: 'construction_standards', cat: 'Standards & Codes', keys: 'substrate_moisture, ambient_temperature, wind_speed, ponding_water, adhesive_expired, primer_omitted, precipitation, deck_deflection' },
  { kind: 'fn', name: 'authority_requirement', sig: 'authority_requirement(activity: String) -> AuthorityRequirement', module: 'construction_standards', cat: 'Standards & Codes', keys: 'roof_design, structural, fire_rated, change_order, special_inspection, fall_protection, warranty, reroofing' },
  { kind: 'fn', name: 'climate_zone_r_value', sig: 'climate_zone_r_value(zone: Int) -> ClimateZoneRValue', module: 'construction_standards', cat: 'Standards & Codes', keys: 'Zone 1-8: Miami to Fairbanks, R-25 to R-35' },
  { kind: 'fn', name: 'ibc_reference', sig: 'ibc_reference(section: String) -> String', module: 'construction_standards', cat: 'Standards & Codes', keys: 'chapter_15, 1504, 1507, 1510, 1704, 2603, iecc_c402' },

  // Geohazards - geohazards.sy
  { kind: 'fn', name: 'sinkhole_risk', sig: 'sinkhole_risk(bedrock_type: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'limestone HIGH, dolomite HIGH, gypsum VERY HIGH, marble MODERATE, sandstone LOW, granite NEGLIGIBLE, basalt NEGLIGIBLE' },
  { kind: 'fn', name: 'karst_formation_type', sig: 'karst_formation_type(name: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'cover_collapse, cover_subsidence, solution' },
  { kind: 'fn', name: 'sinkhole_investigation', sig: 'sinkhole_investigation(method: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'GPR, SPT, CPT, ERI, microgravity, borings' },
  { kind: 'fn', name: 'sinkhole_prone_state', sig: 'sinkhole_prone_state(st: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'FL, AL, TN, KY, MO, TX, PA' },
  { kind: 'fn', name: 'dissolution_rate', sig: 'dissolution_rate(rock_type: String, rainfall: Float, co2: Float) -> Float', module: 'geohazards', cat: 'Geohazards & Geology', keys: '' },
  { kind: 'fn', name: 'mineral_deposit', sig: 'mineral_deposit(name: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'iron_oxide, pyrite, gypsum, calcite, montmorillonite, kaolinite, illite, sulfate_salts, chlorides, organic_matter' },
  { kind: 'fn', name: 'sulfate_attack_risk', sig: 'sulfate_attack_risk(sulfate_ppm: Float) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'S0, S1, S2, S3 per ACI 318' },
  { kind: 'fn', name: 'concrete_sulfate_resistance', sig: 'concrete_sulfate_resistance(exposure: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: '' },
  { kind: 'fn', name: 'swell_potential', sig: 'swell_potential(PI: Float, LL: Float) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'Low, Medium, High, Very High' },
  { kind: 'fn', name: 'expansive_soil_mitigation', sig: 'expansive_soil_mitigation(method: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'moisture_barrier, deepened_foundations, drilled_shafts, structural_slab, lime_stabilization, removal' },
  { kind: 'fn', name: 'water_table_effect', sig: 'water_table_effect(depth_ft: Float) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: '' },
  { kind: 'fn', name: 'hydrostatic_pressure', sig: 'hydrostatic_pressure(depth_ft: Float) -> Float', module: 'geohazards', cat: 'Geohazards & Geology', keys: '' },
  { kind: 'fn', name: 'dewatering_method', sig: 'dewatering_method(soil_type: String, depth: Float) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'wellpoints, deep_wells, sumps, cutoff_walls, ground_freezing' },
  { kind: 'fn', name: 'liquefaction_risk', sig: 'liquefaction_risk(soil: String, gw_depth: Float, seismic: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: '' },
  { kind: 'fn', name: 'slope_angle_safe', sig: 'slope_angle_safe(soil_type: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'rock, dense_sand, loose_sand, stiff_clay, soft_clay' },
  { kind: 'fn', name: 'osha_soil_classification', sig: 'osha_soil_classification(type: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'A, B, C per OSHA Subpart P' },
  { kind: 'fn', name: 'radon_risk_zone', sig: 'radon_risk_zone(zone: Int) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'Zone 1 HIGH, Zone 2 MODERATE, Zone 3 LOW' },
  { kind: 'fn', name: 'frost_depth', sig: 'frost_depth(climate_zone: Int) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: '' },
  { kind: 'fn', name: 'frost_heave_risk', sig: 'frost_heave_risk(soil_type: String) -> String', module: 'geohazards', cat: 'Geohazards & Geology', keys: 'silt HIGH, fine_sand HIGH, clay MODERATE, gravel LOW' },
  { kind: 'fn', name: 'composite_site_risk', sig: 'composite_site_risk(sinkhole, mineral, expansive, groundwater, slope: String) -> Float', module: 'geohazards', cat: 'Geohazards & Geology', keys: '' },
];

const CATEGORIES = ['All', 'Standards & Codes', 'Geohazards & Geology'];

export default function ScylaConstructionPage() {
  const bgRef = useRef(null);
  const [search, setSearch] = useState('');
  const [activeCat, setActiveCat] = useState('All');

  useEffect(() => {
    const handleScroll = () => {
      if (bgRef.current) {
        const scrolled = window.scrollY;
        bgRef.current.style.transform = `scale(1.05) translateY(${scrolled * 0.3}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const filtered = CONSTRUCTION_DATA.filter(row => {
    const q = search.toLowerCase();
    const matchesSearch = !q || `${row.name} ${row.module} ${row.cat} ${row.keys}`.toLowerCase().includes(q);
    const matchesCat = activeCat === 'All' || row.cat === activeCat;
    return matchesSearch && matchesCat;
  });

  const totalFns = CONSTRUCTION_DATA.filter(r => r.kind === 'fn').length;
  const totalStructs = CONSTRUCTION_DATA.filter(r => r.kind === 'struct').length;

  return (
    <div>
      {/* HERO */}
      <section className="hero" id="top" style={{ minHeight: '70vh' }}>
        <div className="hero-bg" ref={bgRef} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/hero-bg.png)` }} />
        <div className="hero-overlay" />
        <div className="hero-content">
          <img src="/assets/NexusLogo.png" alt="Nexus Concordat" className="hero-logo" />
          <span className="hero-label">Nexus Concordat &middot; Scyla Code Bank</span>
          <h1 className="hero-title">
            Construction Module<br />
            <span className="gold">Division 07 Reference</span>
          </h1>
          <p className="hero-sub" style={{ maxWidth: 600 }}>
            Regulatory bodies, building codes, material compatibility, geohazards, and engineering physics.
            Every constraint cited. Every rule compiled. No hallucination.
          </p>
        </div>
      </section>

      {/* STATS */}
      <section style={{ padding: '3rem 2rem', background: 'var(--bg-warm)' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', display: 'flex', justifyContent: 'center', gap: '3rem', flexWrap: 'wrap', textAlign: 'center' }}>
          {[
            [totalFns, 'Functions'],
            [totalStructs, 'Structs'],
            [2, 'Modules'],
            [17, 'Regulatory Bodies'],
            [10, 'Material Rules'],
            [8, 'Climate Zones'],
          ].map(([num, label]) => (
            <div key={label}>
              <div style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--gold)', fontFamily: "'JetBrains Mono', monospace" }}>{num}</div>
              <div style={{ fontSize: '0.6rem', textTransform: 'uppercase', letterSpacing: '0.12em', color: 'var(--text-dim)' }}>{label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* VALUE PROPS */}
      <section style={{ padding: '3rem 2rem', background: 'var(--bg)' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem' }}>
          <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 10, padding: '1.5rem' }}>
            <h3 style={{ color: 'var(--gold)', fontSize: '0.9rem', marginBottom: '0.5rem' }}>Material Compatibility</h3>
            <p style={{ color: 'var(--text-sub)', fontSize: '0.8rem', lineHeight: 1.7 }}>
              <code style={{ color: '#4ecdc4', background: 'rgba(78,205,196,0.08)', padding: '0.1rem 0.3rem', borderRadius: 3, fontSize: '0.75rem' }}>material_compatibility(1)</code> returns:
              "EPDM SHALL NOT contact bitumen. Petroleum solvents cause swelling. Irreversible." With NRCA citation.
            </p>
          </div>
          <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 10, padding: '1.5rem' }}>
            <h3 style={{ color: 'var(--gold)', fontSize: '0.9rem', marginBottom: '0.5rem' }}>Failure Mode Detection</h3>
            <p style={{ color: 'var(--text-sub)', fontSize: '0.8rem', lineHeight: 1.7 }}>
              <code style={{ color: '#4ecdc4', background: 'rgba(78,205,196,0.08)', padding: '0.1rem 0.3rem', borderRadius: 3, fontSize: '0.75rem' }}>failure_mode("substrate_moisture")</code> returns:
              threshold (25%), action (HALT), citation (ASTM D4263). The compiler enforces the halt.
            </p>
          </div>
          <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 10, padding: '1.5rem' }}>
            <h3 style={{ color: 'var(--gold)', fontSize: '0.9rem', marginBottom: '0.5rem' }}>Sinkhole Risk Assessment</h3>
            <p style={{ color: 'var(--text-sub)', fontSize: '0.8rem', lineHeight: 1.7 }}>
              <code style={{ color: '#4ecdc4', background: 'rgba(78,205,196,0.08)', padding: '0.1rem 0.3rem', borderRadius: 3, fontSize: '0.75rem' }}>sinkhole_risk("limestone")</code> returns:
              HIGH. With karst formation types, investigation methods, and safe setback distances. From USGS data.
            </p>
          </div>
        </div>
      </section>

      {/* SEARCH + TABLE */}
      <section style={{ padding: '2rem 2rem 4rem', background: 'var(--bg)' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <input
            type="text"
            placeholder="Search: EPDM, sinkhole, wind, ASTM, limestone, frost, pyrite..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{
              width: '100%', padding: '0.8rem 1rem', fontSize: '0.9rem',
              fontFamily: "'Space Grotesk', sans-serif",
              background: 'var(--bg-card)', border: '1px solid var(--border)',
              borderRadius: 8, color: 'var(--text)', outline: 'none',
              marginBottom: '1rem',
            }}
          />

          <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                onClick={() => setActiveCat(cat)}
                style={{
                  padding: '0.35rem 0.8rem', fontSize: '0.72rem',
                  fontFamily: "'Space Grotesk', sans-serif",
                  background: activeCat === cat ? 'var(--gold-glow)' : 'var(--bg-card)',
                  border: `1px solid ${activeCat === cat ? 'var(--gold)' : 'var(--border)'}`,
                  borderRadius: 20,
                  color: activeCat === cat ? 'var(--gold)' : 'var(--text-dim)',
                  cursor: 'pointer',
                }}
              >
                {cat} ({cat === 'All' ? CONSTRUCTION_DATA.length : CONSTRUCTION_DATA.filter(r => r.cat === cat).length})
              </button>
            ))}
          </div>

          <div style={{ fontSize: '0.7rem', color: 'var(--text-dim)', marginBottom: '0.5rem' }}>
            Showing {filtered.length} of {CONSTRUCTION_DATA.length} entries | Code Bank Sample | Patent pending 64/034,536
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {['Type', 'Name', 'Signature', 'Module', 'Category', 'Data Keys'].map(h => (
                    <th key={h} style={{
                      textAlign: 'left', padding: '0.6rem 0.8rem', fontSize: '0.6rem',
                      fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em',
                      color: 'var(--gold)', borderBottom: '2px solid var(--border)',
                      background: 'var(--bg)',
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((row, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid rgba(201,168,76,0.05)' }}>
                    <td style={{ padding: '0.5rem 0.8rem' }}>
                      <span style={{
                        display: 'inline-block', padding: '0.12rem 0.4rem', borderRadius: 3,
                        fontSize: '0.55rem', fontWeight: 700, textTransform: 'uppercase',
                        background: row.kind === 'fn' ? 'rgba(78,205,196,0.1)' : 'rgba(155,114,207,0.1)',
                        color: row.kind === 'fn' ? '#4ecdc4' : '#9b72cf',
                        border: `1px solid ${row.kind === 'fn' ? 'rgba(78,205,196,0.2)' : 'rgba(155,114,207,0.2)'}`,
                      }}>{row.kind}</span>
                    </td>
                    <td style={{ padding: '0.5rem 0.8rem' }}>
                      <code style={{ color: '#4ecdc4', fontWeight: 600, fontSize: '0.8rem' }}>{row.name}</code>
                    </td>
                    <td style={{ padding: '0.5rem 0.8rem' }}>
                      <code style={{ color: 'var(--text-sub)', fontSize: '0.7rem' }}>{row.sig}</code>
                    </td>
                    <td style={{ padding: '0.5rem 0.8rem', color: '#50c878', fontSize: '0.75rem' }}>{row.module}</td>
                    <td style={{ padding: '0.5rem 0.8rem', color: '#9b72cf', fontSize: '0.72rem' }}>{row.cat}</td>
                    <td style={{ padding: '0.5rem 0.8rem', color: 'var(--text-dim)', fontSize: '0.65rem', wordBreak: 'break-word' }}>
                      {row.keys || '--'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '3rem 2rem', background: 'var(--bg-warm)', textAlign: 'center', borderTop: '1px solid var(--border)' }}>
        <p style={{ color: 'var(--gold)', fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '0.8rem' }}>Interested?</p>
        <h2 style={{ fontFamily: "'Comfortaa', cursive", fontSize: '1.4rem', fontWeight: 400, color: 'var(--text)', marginBottom: '1rem' }}>
          Build a Division 07 Code Bank for your organization
        </h2>
        <p style={{ color: 'var(--text-sub)', fontSize: '0.85rem', maxWidth: 550, margin: '0 auto 1.5rem', lineHeight: 1.7 }}>
          Your material compatibility rules, your failure modes, your authority chain, your ASTM references, compiled into native Scyla. Every constraint cited. Every rule enforceable.
        </p>
        <a href="/contact" style={{
          display: 'inline-block', padding: '0.8rem 2rem',
          fontFamily: "'Comfortaa', cursive", fontSize: '0.85rem', fontWeight: 600,
          color: 'var(--bg)', background: 'var(--gold)', borderRadius: 8,
          textDecoration: 'none', letterSpacing: '0.05em',
        }}>Contact Us</a>
      </section>

      {/* FOOTER */}
      <footer style={{ textAlign: 'center', padding: '2rem', borderTop: '1px solid var(--border)', color: 'var(--text-dim)', fontSize: '0.65rem', lineHeight: 2 }}>
        <p>Scyla Construction Module -- Code Bank Sample (Licensed Addon)</p>
        <p>Patent pending: 64/034,536 | Nexus Concordat Inc. | Marjorie McCubbins + Aislinn McCubbins + Aether, 2026</p>
      </footer>
    </div>
  );
}
